const SyncStatus: {
  ACCEPTED: string;
  REJECTED: string;
  NOT_SUPPORTED: string;
  UNKNOWN: string;
} = {
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected',
  NOT_SUPPORTED: 'NotSupported',
  UNKNOWN: 'Unknown',
};

export default SyncStatus;
